import { createFileRoute } from "@tanstack/react-router";
import { AttendanceGate } from "@/components/attendance/attendance-locked";
import { SessionDetail } from "@/components/attendance/session-detail";
import { attendanceSessionQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/attendance/$id")({
  loader: ({ context, params }) => {
    warm(context.queryClient.ensureQueryData(attendanceSessionQuery(params.id)));
  },
  component: SessionDetailPage,
});

function SessionDetailPage() {
  const { id } = Route.useParams();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl">
        <AttendanceGate>
          <SessionDetail id={id} />
        </AttendanceGate>
      </div>
    </main>
  );
}
